// Compression suffixes that ride on top of an inner archive extension, so the
// label keeps both parts (`archive.tar.gz` → `TAR.GZ`, not `GZ`).
const COMPOUND_TAIL = new Set(['gz', 'bz2', 'xz', 'zst', 'lz', 'z']);

/**
 * Short uppercase kind label for a knowledge-base file — the quiet half of the
 * row, beside the name that carries it.
 *
 * Same rule as the sandbox attachment card's `documentTypeLabel`
 * (MessageAttachments.functions.ts), reimplemented here on purpose: that one
 * lives in the Onboarding page tree, and MessageSources is a shared component
 * mounted in both the Chat and the sandbox trees. The behaviour differs in one
 * deliberate way — it returns undefined instead of 'FILE' when there is no
 * extension, because a knowledge-base entry is often a plain title
 * ("ALTURA BIENES RAÍCES — FICHAS DE PROPIEDADES") and a literal "FILE" beside
 * it is noise, not information.
 *
 * Lives outside the component file so Vite's React Fast Refresh does not
 * re-mount the component when a non-component export changes.
 */
export function sourceFileKind(name: string): string | undefined {
  const parts = name.split('.');
  if (parts.length < 2) return undefined;

  const last = parts[parts.length - 1];
  // A trailing dot, or a "segment" that is really the rest of a sentence
  // ("catálogo vigente. Actualizado") — an extension has no spaces.
  if (!last || last.includes(' ')) return undefined;

  const inner = parts[parts.length - 2];
  if (inner && COMPOUND_TAIL.has(last.toLowerCase())) {
    return `${inner}.${last}`.toUpperCase();
  }
  return last.toUpperCase();
}
